import {connect} from "react-redux";
import Listing from "./Listing";
import {bindActionCreators} from "redux";
import {taskListing, removeTask, taskFilter} from "../../../service/Task/action";

const mapStateToProps = (state) => ({
    listing:state.Task.listing,
    removeTaskDetails:state.Task.removeTask,
    filter:state.Task.filter
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            taskListing,
            removeTask,
            taskFilter
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Listing);
